import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useGetCrmDataQuery } from 'generated/graphql';

import { getCreatorApiUrl } from '@client/components/api-urls';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import {
  BundlePricing,
  BusinessModel,
} from '@playbook-technologies/common-enums';

import { FilterOption } from '../filter-option';

type Bundle = {
  title: string;
  pricing: BundlePricing;
};

const fetchBundles = async (creatorId: number): Promise<Bundle[]> => {
  const url = new URL(getCreatorApiUrl('/bundles'));

  const response = await axios.get<Bundle[]>(url.toString(), {
    params: {
      influencerId: creatorId,
    },
  });

  return response.data;
};

const PRODUCTS_BY_VISIBILITY: { [key: string]: FilterOption[] } = {
  premium: [{ id: 'Premium', label: 'Premium' }],
  exclusive: [{ id: 'Exclusive', label: 'Exclusive' }],
  limited: [
    { id: 'Limited', label: 'Limited' },
    { id: 'Premium', label: 'Premium' },
  ],
};

export const useProductOptions = (): FilterOption[] => {
  const creatorId = useInfluencerId();
  const result = useGetCrmDataQuery({
    variables: {
      creatorId,
    },
  });
  const { isFetched, data: bundles } = useQuery(['bundles', creatorId], () =>
    fetchBundles(creatorId),
  );

  const visibility = result.data?.creator?.visibility;
  const businessModel = result.data?.creator?.businessModel;

  if (businessModel === BusinessModel.Bundle) {
    if (isFetched && bundles) {
      return bundles
        .filter((b) => b.pricing === BundlePricing.SUBSCRIPTION)
        .map((b) => ({ id: b.title, label: b.title }));
    } else {
      return [];
    }
  }

  return visibility ? PRODUCTS_BY_VISIBILITY[visibility] ?? [] : [];
};
